// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3E47J","header":"ClearentDisclaimer_header__3pqtr","inner":"ClearentDisclaimer_inner__BjL0e"};